/*
Replace
recipe with your resource Name :) Take care about different writings!
/!\ Recipe recipe Recipes recipes /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const recipeSlice = createSlice({
  name: "recipes",
  initialState: {
    ...defaultInitialState,
    types: [],
  },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
    listTypes: (state, action) => { state.types = action.payload },
  },
});

export const {
  list: listRecipes,
  show: showRecipe,
  create: createRecipe,
  update: updateRecipe,
  listTypes: listRecipeTypes,
} = recipeSlice.actions;

export const actions = recipeSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const recipes = (state) =>
  state.recipes.idsList.map((id) => state.recipes.dictionary[id]);
export const recipe = (state) =>
  state.recipes.showId && state.recipes.dictionary[state.recipes.showId];
export const recipeAttributes = (state) => recipe(state)?.attributes;
export const recipeRelationships = (state) => recipe(state)?.relationships;
export const recipeId = (state) => state.recipes.showId;

export const getRecipe = createSelector(
  (state) => state.recipes.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getRecipeAttributes = createSelector(
  (state) => state.recipes.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getRecipeRelationships = createSelector(
  (state) => state.recipes.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getRecipes = createSelector(
  (state) => state.recipes.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export const getRecipeDishRecipeIngredientsIds = createSelector(
  (state) => state.recipes.dictionary,
  (state) => state.dishRecipeIngredients.dictionary,
  (_, id) => id,
  (dictionary, dishRecipeIngredientDictionary, id) => {
    let dishRecipeIngredientIds = [];
    if (
      id &&
      dictionary &&
      dictionary[id]?.relationships.dish_recipe_ingredients
    ) {
      dictionary[id]?.relationships.dish_recipe_ingredients.data.forEach(
        (dri) => {
          if (
            dishRecipeIngredientDictionary[dri.id] &&
            dishRecipeIngredientDictionary[dri.id]?.attributes
              ?.nested_recipe_id === id
          ) {
            dishRecipeIngredientIds.push(id);
          }
        }
      );
    }
    return dishRecipeIngredientIds;
  }
);

export default recipeSlice.reducer;
